import { DASHBOARD_SET_FILTER } from './constants'

export function setFilter(filterData) {
    return (dispatch) =>{
      dispatch({
      type: DASHBOARD_SET_FILTER,
      data: filterData
      })
  };
}

export function reducer(state, action) {
  if (action.type === DASHBOARD_SET_FILTER) {
    return {  
      ...state,  
      filters: {...state.filters , ...action.data}
    }
  }
  else {
    return state
    }
}